import React from 'react';
import Link from 'components/general/Link/Link';
import * as R from 'ramda';
import Banner from 'components/general/Banner/Banner';
import SkeletonBanner from 'components/general/Banner/SkeletonBanner';
import Icon from 'components/general/Icon/Icon';
import SiteSubNav from 'containers/SiteSubNav';
import AccountMain from './../containers/AccountMain';

const Account = ({ customer, navItems }) => (
  <div className="l-sub-page">
    {!R.isEmpty(customer) && (
      <div className="l-sub-page__banner">
        {R.path(['loading', 'state'], customer) === 'LOADING' ? (
          <SkeletonBanner />
        ) : (
          <Banner
            renderMessage={() => (
            <span>
              <Link to={{ type: 'ORGANISATION_CUSTOMERS' }}>
                <Icon name="chevron-left" />
                Back
              </Link>
              &nbsp; Viewing {R.path(['data', 'name'], customer)}
            </span>
            )}
          />
        )}
      </div>
    )}
    <div className="l-sub-page__aside">
      <SiteSubNav items={navItems} />
    </div>
    <AccountMain />
  </div>
);

export default Account;
